export const products = [
  {
    id: 'p1',
    name: '爱液·水润亲肤润滑液',
    slug: 'water-based-moisturizing',
    category: 'water-based',
    categoryName: '水基润滑液',
    price: '¥89',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20sleek%20personal%20lubricant%20bottle%20with%20soft%20water%20droplets%20on%20surface%2C%20clean%20white%20studio%20background%20with%20gentle%20warm%20lighting%2C%20premium%20cosmetic%20aesthetic%2C%20soft%20rose%20gold%20accents%2C%20luxury%20wellness%20brand%20style%2C%20professional%20commercial%20product%20shot%20with%20shallow%20depth%20of%20field%2C%20delicate%20atmosphere&width=800&height=800&seq=aiye-product-water-01&orientation=squarish',
    description: '采用天然水溶性配方，质地轻盈不黏腻，温和亲肤，适合日常使用。蕴含天然植物精华，长效滋润呵护私密肌肤，PH值温和无刺激。',
    features: ['水溶性配方，易于清洗', 'PH值温和不刺激', '植物精华滋养', '无香精无色素', '适合敏感肌肤'],
    usage: '取适量涂抹于所需部位，可根据需要随时补充。使用后以清水洗净即可。',
    ingredients: '水、甘油、丙二醇、羟乙基纤维素、透明质酸钠、维生素E、植物提取物',
    spec: '200ml / 瓶'
  },
  {
    id: 'p2',
    name: '爱液·丝滑硅基润滑液',
    slug: 'silicone-smooth',
    category: 'silicone-based',
    categoryName: '硅基润滑液',
    price: '¥128',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20premium%20silicone%20based%20lubricant%20bottle%20with%20silky%20texture%20visual%2C%20clean%20white%20studio%20background%20with%20soft%20warm%20lighting%2C%20luxury%20cosmetic%20aesthetic%2C%20rose%20gold%20metallic%20details%2C%20professional%20wellness%20product%20photography%2C%20elegant%20minimal%20composition%2C%20sophisticated%20brand%20identity&width=800&height=800&seq=aiye-product-silicone-01&orientation=squarish',
    description: '高端硅基配方，极致丝滑持久润滑，不溶于水，特别适合水下使用。超高顺滑度带来非凡体验，用量少效果持久。',
    features: ['超长持久润滑', '防水配方，适合水下使用', '用量极少效果卓越', '无味无刺激', '医美级安全标准'],
    usage: '取极少量涂抹于所需部位，硅基配方用量更省。不可与硅胶玩具同时使用。',
    ingredients: '二甲基硅油、二甲基硅醇、维生素E衍生物',
    spec: '150ml / 瓶'
  },
  {
    id: 'p3',
    name: '爱液·玻尿酸水光润滑液',
    slug: 'hyaluronic-acid-glow',
    category: 'water-based',
    categoryName: '水基润滑液',
    price: '¥118',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20lubricant%20bottle%20with%20hyaluronic%20acid%20glowing%20droplets%2C%20clean%20white%20studio%20background%20with%20warm%20soft%20lighting%2C%20premium%20skincare%20aesthetic%2C%20rose%20gold%20and%20coral%20accents%2C%20luxury%20wellness%20brand%20photography%2C%20dewy%20fresh%20look%2C%20professional%20product%20shot&width=800&height=800&seq=aiye-product-ha-01&orientation=squarish',
    description: '三重玻尿酸科技，深层补水锁水，带来水光般丝滑触感。大分子玻尿酸形成保护膜，小分子玻尿酸深层渗透，长效滋润不干涩。',
    features: ['三重玻尿酸科技', '深层补水锁水', '形成天然保护膜', '修复私密肌肤屏障', '医美级配方'],
    usage: '取适量涂抹于所需部位，玻尿酸成分可持续释放滋润，无需频繁补充。',
    ingredients: '水、透明质酸钠（三重分子量）、甘油、泛醇、神经酰胺、植物鞘氨醇',
    spec: '180ml / 瓶'
  },
  {
    id: 'p4',
    name: '爱液·天然植萃润滑液',
    slug: 'natural-botanical',
    category: 'natural',
    categoryName: '天然植萃系列',
    price: '¥99',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20natural%20organic%20lubricant%20bottle%20with%20botanical%20leaves%20elements%2C%20clean%20white%20studio%20background%20with%20warm%20natural%20lighting%2C%20eco%20friendly%20wellness%20aesthetic%2C%20soft%20green%20and%20coral%20accents%2C%20premium%20natural%20cosmetic%20brand%20style%2C%20professional%20product%20shot%20with%20organic%20texture&width=800&height=800&seq=aiye-product-natural-01&orientation=squarish',
    description: '100%天然植物萃取，芦荟与金盏花精华温和呵护，适合极度敏感肌肤。无化学添加，孕妇可使用，给宝宝般的温柔呵护。',
    features: ['100%天然植物萃取', '芦荟+金盏花双效舒缓', '零化学添加', '孕妇友好配方', '极度敏感肌适用'],
    usage: '取适量涂抹于所需部位。本品为天然配方，冷藏后使用体验更佳。',
    ingredients: '芦荟叶汁、金盏花萃取物、植物甘油、黄原胶、维生素E',
    spec: '200ml / 瓶'
  },
  {
    id: 'p5',
    name: '爱液·热感激情润滑液',
    slug: 'warming-sensation',
    category: 'silicone-based',
    categoryName: '硅基润滑液',
    price: '¥138',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20warming%20sensation%20lubricant%20bottle%20with%20soft%20amber%20glow%2C%20clean%20white%20studio%20background%20with%20warm%20candlelight%20atmosphere%2C%20premium%20wellness%20cosmetic%20aesthetic%2C%20rose%20gold%20and%20warm%20coral%20details%2C%20luxury%20brand%20photography%2C%20intimate%20sophisticated%20style&width=800&height=800&seq=aiye-product-warm-01&orientation=squarish',
    description: '独特微热感科技，接触肌肤后产生温和暖意，提升感官体验。硅基配方顺滑持久，配合温热感带来双重享受。',
    features: ['微热感科技', '提升感官体验', '硅基持久配方', '体温激活温热', '温和不刺激'],
    usage: '取适量涂抹于所需部位，约30秒后感受微妙温热。初次使用建议少量测试。',
    ingredients: '二甲基硅油、温感因子、薄荷醇衍生物、维生素E',
    spec: '150ml / 瓶'
  },
  {
    id: 'p6',
    name: '爱液·修护滋养润滑液',
    slug: 'repair-nourishing',
    category: 'water-based',
    categoryName: '水基润滑液',
    price: '¥108',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20nourishing%20repair%20lubricant%20bottle%20with%20pearl%20like%20sheen%2C%20clean%20white%20studio%20background%20with%20soft%20feminine%20lighting%2C%20premium%20intimate%20skincare%20aesthetic%2C%20rose%20gold%20and%20soft%20pink%20accents%2C%20luxury%20wellness%20brand%20photography%2C%20delicate%20elegant%20composition&width=800&height=800&seq=aiye-product-repair-01&orientation=squarish',
    description: '专为私密肌肤修护研发，添加神经酰胺和益生元，修护肌肤屏障，平衡微生态环境。日常护理型润滑液，呵护娇嫩私密肌肤。',
    features: ['神经酰胺修护屏障', '益生元平衡微生态', '日常护理配方', '增强肌肤自护力', '弱酸性PH值'],
    usage: '每日取适量涂抹，轻柔按摩至吸收，无需冲洗。建议连续使用28天为一个护理周期。',
    ingredients: '水、神经酰胺NP、益生元（α-葡聚糖寡糖）、甘油、角鲨烷、乳酸',
    spec: '200ml / 瓶'
  }
];

export const categories = [
  { id: 'all', name: '全部产品' },
  { id: 'water-based', name: '水基润滑液' },
  { id: 'silicone-based', name: '硅基润滑液' },
  { id: 'natural', name: '天然植萃系列' }
];